import { render } from "./ArticlesTable.vue?vue&type=template&id=7d92084c&scoped=true"
import script from "./ArticlesTable.vue?vue&type=script&lang=js"
export * from "./ArticlesTable.vue?vue&type=script&lang=js"

import "./ArticlesTable.vue?vue&type=style&index=0&id=7d92084c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d92084c"]])

export default __exports__